// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZPzD","name":"Header_name__2kJwQ","birthday":"Header_birthday__3fI7G","skeleton":"Header_skeleton__2nz24"};